import { QueryParams } from 'APIs/types';
import { DateFilterQueryInput, DateFilterValue, toLocalDateFilterInput } from 'Components/Common/Filters/DateFilter';
import { MultiSelectFilterValue } from 'Components/Common/Filters/MultiSelectFilter';
import { TextFilterValue } from 'Components/Common/Filters/TextFilter';
import { FilterOption } from 'Components/Common/Filters/types';
import { merchantBusinessTypes } from 'Constants/Constants';

export const initFilterOptions: FilterOption[] = [
  {
    option_id: 'businessName',
    checked: false,
    value: null,
    label: 'Business name',
    optionType: 'text',
  },
  {
    option_id: 'stateUpdatedOn',
    checked: false,
    value: null,
    label: 'State updated on',
    optionType: 'date',
    optionConfig: {
      conditions: ['is_in_the_last', 'is_equal_to', 'is_between', 'is_after', 'is_before'],
    },
  },
  {
    option_id: 'businessType',
    checked: false,
    value: null,
    label: 'Business type',
    optionType: 'multi_select',
    optionConfig: {
      options: merchantBusinessTypes,
    },
  },
  {
    option_id: 'status',
    checked: false,
    value: null,
    label: 'Status',
    optionType: 'multi_select',
    optionConfig: {
      options: [
        { value: 'Pending', label: 'Pending' },
        { value: 'Active', label: 'Active' },
        { value: 'Suspended', label: 'Suspended' },
      ],
    },
  },
];

export const filterQueryParams = (filterOptionValues: FilterOption[]): QueryParams => {
  return filterOptionValues.reduce((acc: QueryParams, option) => {
    if (option.checked && option.value !== null) {
      if (option.option_id === 'businessName') {
        const value = option.value as TextFilterValue;
        acc['businessName'] = value.text as string;
      }
      if (option.option_id === 'businessType') {
        const value = option.value as MultiSelectFilterValue;
        acc['businessType'] = value?.join(',') as string;
      }
      if (option.option_id === 'status') {
        const value = option.value as MultiSelectFilterValue;
        acc['status'] = value?.join(',') as string;
      }
      if (option.option_id === 'stateUpdatedOn') {
        const dateValue: DateFilterQueryInput | null = toLocalDateFilterInput(option.value as DateFilterValue);

        if (dateValue) {
          if ('gt' in dateValue) {
            acc['from'] = dateValue.gt as string;
          }
          if ('gte' in dateValue) {
            acc['from'] = dateValue.gte as string;
          }
          if ('lt' in dateValue) {
            acc['to'] = dateValue.lt as string;
          }
          if ('lte' in dateValue) {
            acc['to'] = dateValue.lte as string;
          }
        }
      }
    }
    return acc;
  }, {});
};
